module.exports = __webpack_public_path__ + "static/media/banner-pesquisa-usabilidade-indecx-mobile.d529a35c.jpg";